import React from 'react';
import { Skeleton } from '@mui/material';
import { Container } from './styles';

const SkeletonStatus = () => {
  return (
    <Container>
        <Skeleton
          variant="rectangular"
          height="100%"
          width="100%"
          animation="wave"
          style={{ borderRadius: '4px' }}
        />
    </Container>
  );
};

export default SkeletonStatus;
